import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { McpClient, McpServer } from '../models/mcp.model';

export interface McpPaginatedResponse<T> {
  items: T[];
  total: number;
}

@Injectable({
  providedIn: 'root',
})
export class McpService {
  private http = inject(HttpClient);
  private apiUrl = environment.backendUrl + '/api/mcp';

  getMcpServers(
    page = 1,
    pageSize = 12,
    sort: 'stars' | 'downloads' | 'alphabetical' = 'stars',
    searchTerm?: string,
    serverType: 'all' | 'official' | 'archived' | 'community' = 'all'
  ): Observable<McpPaginatedResponse<McpServer>> {
    let params = new HttpParams().set('page', page.toString()).set('pageSize', pageSize.toString()).set('sort', sort);

    if (searchTerm) {
      params = params.set('search', searchTerm);
    }

    // Add server type filter as a separate parameter
    if (serverType !== 'all') {
      params = params.set('type', serverType);
    }

    return this.http
      .get<{ servers: McpServer[]; total: number }>(`${this.apiUrl}/servers`, {
        params,
        headers: { 'x-no-cache': 'true' },
      })
      .pipe(map(response => ({ items: response.servers, total: response.total })));
  }

  getMcpClients(
    page = 1,
    pageSize = 12,
    sort: 'stars' | 'alphabetical' = 'stars',
    searchTerm?: string,
    featured: 'all' | 'featured' = 'all'
  ): Observable<McpPaginatedResponse<McpClient>> {
    let params = new HttpParams().set('page', page.toString()).set('pageSize', pageSize.toString()).set('sort', sort);

    if (searchTerm) {
      params = params.set('search', searchTerm);
    }

    // Add featured filter as a separate parameter
    if (featured === 'featured') {
      params = params.set('featured', 'true');
    }

    return this.http
      .get<{ clients: McpClient[]; total: number }>(`${this.apiUrl}/clients`, {
        params,
        headers: { 'x-no-cache': 'true' },
      })
      .pipe(map(response => ({ items: response.clients, total: response.total })));
  }
}
